import { Link } from 'react-router-dom';
import { useT } from '@/i18n/LocaleProvider';
import { registerEnglishArea } from '@/i18n/catalogue';
import { onboarding } from '@featit/shared/i18n/messages/en/onboarding';

registerEnglishArea('onboarding', onboarding);
import { ArrowLeft } from 'lucide-react';
import { isDesktopRuntime } from '@/desktop/desktopDetection';
import { signedOutQuietLinkClasses } from '@/features/auth/signedOutChrome';
import { FIRST_SCREEN_PATH } from './firstScreen';
import { backNavigation } from '@/shell/backNavigation';

/**
 * The way back to Create account and Sign in, on the desktop (F-0518, AC-FD8).
 *
 * A desktop window has no browser back button, so a person who opened *Sign in* and meant *Create
 * account*, or wants another server, would otherwise be stuck on the form. A browser tab has its own
 * back button and no first screen, so nothing is drawn there.
 */
export function BackToFirstScreen() {
  const t = useT();
  if (!isDesktopRuntime()) return null;
  return (
    <p className="mb-2">
      <Link
        to={FIRST_SCREEN_PATH}
        state={backNavigation().state}
        className={signedOutQuietLinkClasses}
      >
        <ArrowLeft className="mr-1 h-3.5 w-3.5" aria-hidden="true" />
        {t('onboarding.common.back')}
      </Link>
    </p>
  );
}
